// ACTION
export const UTILS = {
  SET_DEVICE_TYPE: 'SET_DEVICE_TYPE',
  SET_WINDOW_WIDTH: 'SET_WINDOW_WIDTH',
  SET_PAGE_BREAKPOINT: 'SET_PAGE_BREAKPOINT'
};

// ACTION CREATORS

// set device type
export const setDeviceType = (deviceType) => ({
  type: UTILS.SET_DEVICE_TYPE,
  deviceType
});

// set window width
export const setWindowWidth = (windowWidth) => ({
  type: UTILS.SET_WINDOW_WIDTH,
  windowWidth
});

// set current page breakpoint
export const setPageBreakpoint = (pageBreakpoint) => ({
  type: UTILS.SET_PAGE_BREAKPOINT,
  pageBreakpoint
});
